import React, { useEffect, useMemo, useState } from 'react';

import { TableColumn } from '@silverfort/sf-components';

import { ActivityEntity } from '../../../api/types/Insights';
import EntityIdentityColumn from './EntityIdentityColumn';
import PopupTableColumn from './PopupTableColumn';
import { TABS } from './tabs';

const useGetColumns = (selectedTab: number, counterColumnTitle: string, rows: ActivityEntity[]) => {
    const [columns, setColumns] = useState<TableColumn<ActivityEntity>[]>([]);
    const tabName = useMemo(
        () => Object.values(TABS).find((tab) => tab.value === selectedTab)?.name ?? '',
        [selectedTab]
    );

    useEffect(() => {
        setColumns([
            {
                columnKey: 'name',
                title: `${tabName} (${rows?.length})`,
                render: (row) => <EntityIdentityColumn {...row} />
            },
            {
                columnKey: 'count',
                title: `${counterColumnTitle}`,
                render: (row) => <PopupTableColumn text={row.count.toString()} />
            },
            {
                columnKey: 'domainName',
                title: 'Domain name',
                render: (row) => <PopupTableColumn text={row.domainName} />
            }
        ]);
    }, [counterColumnTitle, rows?.length, selectedTab, tabName]);

    return columns;
};

export default useGetColumns;
